"use client";
//#region packages/@mantine/core/src/components/Paper/Paper.module.css
var Paper_module_default = { "root": "m_1b7284a3" };
//#endregion
export { Paper_module_default as default };

//# sourceMappingURL=Paper.module.mjs.map